import {ajaxify} from '../features/ajaxinate';
import {register} from '../vendor/theme-scripts/theme-sections';

register('blog-posts', ajaxify);
